import { Controller } from "@hotwired/stimulus"

// jquery-ujs announces the remote form's result through jQuery's trigger, so `ajax:success`
// never reaches a data-action.
const JQUERY_NAMESPACE = ".accessToken"

export default class extends Controller {
  static get targets() { return ["token", "created"]; }

  connect() {
    $(this.element).on(`ajax:success${JQUERY_NAMESPACE}`, (event, data) => this.render(data))
  }

  disconnect() {
    $(this.element).off(JQUERY_NAMESPACE)
  }

  // textContent, not a write into the nested `.token-text`: jQuery's `.text()` replaced the
  // `.token` div's children, and the copy button's `#live-token .token-text` source goes with them
  // until the page is reloaded.
  render(data) {
    this.tokenTargets.forEach(token => { token.textContent = data.token })
    this.createdTargets.forEach(created => { created.textContent = `Created ${data.created_at}` })
  }
}
